<template>
  <GrupoLeyendaCheck
    titulo="Tipos de suelo (Edafología)"
    v-model="edafologia_expanded"
    checkboxType="switch"
  >
    <!-- <BotonQuitarTodos @click="quitarTodos" v-width-control="'30%'" /> -->
    <span v-width-control="'40%'"></span>
    <BotonMasInfo @click="masInfo" v-width-control="'45%'" />
    <DaiLeyendaMapa
      :para="['edafologia_histosol']"
      titulo="Agrícolas con sistema de canales de riego"
      v-width-control="'100%'"
      :mostrar-boton-alterna-todos="true"
      estilo-boton-alterna-todos="checkbox"
      :colapsable="true"
      :infos="{
        'edafologia_histosol': tooltips['histosol']
      }"
    />
    <hr class="dai-map-separator thin" />
    <DaiLeyendaMapa
      :para="['edafologia_phaeozem']"
      titulo="Agrícolas dependientes del comportamiento de las lluvias"
      v-width-control="'100%'"
      :mostrar-boton-alterna-todos="true"
      estilo-boton-alterna-todos="checkbox"
      :colapsable="true"
      :infos="{
        'edafologia_phaeozem': tooltips['phaeozem']
      }"
    />
    <hr class="dai-map-separator thin" />
    <DaiLeyendaMapa
      :para="['edafologia_andosol']"
      titulo="Agrícolas de regular o baja productividad"
      v-width-control="'100%'"
      :mostrar-boton-alterna-todos="true"
      estilo-boton-alterna-todos="checkbox"
      :colapsable="true"
      :infos="{
        'edafologia_andosol': tooltips['andosol']
      }"
    />
    <hr class="dai-map-separator thin" />
    <DaiLeyendaMapa
      :para="[
        'edafologia_gleysol',
        'edafologia_vertisol',
        'edafologia_fluvisol',
      ]"
      titulo="Agrícolas bastante fértiles"
      v-width-control="'100%'"
      :mostrar-boton-alterna-todos="true"
      estilo-boton-alterna-todos="checkbox"
      :colapsable="true"
      :infos="{
        'edafologia_gleysol': tooltips['gleysol'],
        'edafologia_vertisol': tooltips['vertisol'],
        'edafologia_fluvisol': tooltips['fluvisol'],
      }"
    />
    <hr class="dai-map-separator thin" />
    <DaiLeyendaMapa
      :para="[
        'edafologia_solonchak',
        'edafologia_solonetz',
        'edafologia_calcisols',
      ]"
      titulo="Con exceso de sales - agrícolas con métodos de control de riego"
      v-width-control="'100%'"
      :mostrar-boton-alterna-todos="true"
      estilo-boton-alterna-todos="checkbox"
      :colapsable="true"
      :infos="{
        'edafologia_solonchak': tooltips['solonchak'],
        'edafologia_solonetz': tooltips['solonetz'],
        'edafologia_calcisols': tooltips['calcisol'],
      }"
    />
    <hr class="dai-map-separator thin" />
    <DaiLeyendaMapa
      :para="[
        'edafologia_regosol',
        'edafologia_cambisol',
        'edafologia_arenosol',
      ]"
      titulo="Jóvenes con poco desarrollo - agrícolas con métodos de riego"
      v-width-control="'100%'"
      :mostrar-boton-alterna-todos="true"
      estilo-boton-alterna-todos="checkbox"
      :colapsable="true"
      :infos="{
        'edafologia_regosol': tooltips['regosol'],
        'edafologia_cambisol': tooltips['cambisol'],
        'edafologia_arenosol': tooltips['arenosol'],
      }"
    />
    <hr class="dai-map-separator thin" />
    <DaiLeyendaMapa
      :para="['edafologia_luvisol']"
      titulo="Arcillosos fértiles para la agricultura"
      v-width-control="'100%'"
      :mostrar-boton-alterna-todos="true"
      estilo-boton-alterna-todos="checkbox"
      :colapsable="true"
      :infos="{
        'edafologia_luvisol': tooltips['luvisol']
      }"
    />
    <hr class="dai-map-separator thin" />
    <DaiLeyendaMapa
      :para="[
        'edafologia_leptosol',
        'edafologia_umbrisol',
      ]"
      titulo="Para pastar ganado en verano"
      v-width-control="'100%'"
      :mostrar-boton-alterna-todos="true"
      estilo-boton-alterna-todos="checkbox"
      :colapsable="true"
      :infos="{
        'edafologia_leptosol': tooltips['leptosol'],
        'edafologia_umbrisol': tooltips['umbrisol'],
      }"
    />
    <hr class="dai-map-separator thin" />
    <DaiLeyendaMapa
      :para="[
        'edafologia_durisol',
        'edafologia_planosol',
      ]"
      titulo="Erosionados aptos para pastizales"
      v-width-control="'100%'"
      :mostrar-boton-alterna-todos="true"
      estilo-boton-alterna-todos="checkbox"
      :colapsable="true"
      :infos="{
        'edafologia_durisol': tooltips['durisol'],
        'edafologia_planosol': tooltips['planosol'],
      }"
    />
    <hr class="dai-map-separator thin" />
    <DaiLeyendaMapa
      :para="[
        'edafologia_anthrosols',
        'edafologia_technosol',
      ]"
      titulo="Suelos que han sido modificados por actividades humanas"
      v-width-control="'100%'"
      :mostrar-boton-alterna-todos="true"
      estilo-boton-alterna-todos="checkbox"
      :colapsable="true"
      :infos="{
        'edafologia_anthrosols': tooltips['anthrosol'],
        'edafologia_technosol': tooltips['technosol'],
      }"
    />
    <hr class="dai-map-separator thin" />
    <DaiLeyendaMapa
      :para="['edafologia_tierras_miscelaneas']"
      titulo="Con poco suelo o que soportan o nula vegetación"
      v-width-control="'100%'"
      :mostrar-boton-alterna-todos="true"
      estilo-boton-alterna-todos="checkbox"
      :colapsable="true"
      :infos="{
        'edafologia_tierras_miscelaneas': tooltips['tierras_misc']
      }"
    />
  </GrupoLeyendaCheck>
</template>

<script>
import GrupoLeyendaCheck from "./utils/GrupoLeyendaCheck.vue";
import BotonMasInfo from "./utils/BotonMasInfo.vue";
// import BotonQuitarTodos from "./utils/BotonQuitarTodos.vue";
import { scrollTo } from "@/components/_utils.js";
import tooltips from "./tooltips_edafologia.json"

export default {
  computed: {
    edafologia_expanded: {
      get() {
        return this.$store.state.mapa.temasExpandidos.edafologia;
      },
      set(expandido) {
        this.$store.commit("mapa/setTemasExpandidos", {
          tema: "edafologia",
          expandido: expandido,
        });
      },
    },
  },
  methods: {
    quitarTodos() {
      console.log("apagar todas las capas de edafologia");
    },
    masInfo() {
      this.$store.commit("mapa/setFichaActiva", "edafologia");
      scrollTo(document.querySelector("[data-section='fichas']"),-102);
    },
  },
  components: {
    GrupoLeyendaCheck,
    // BotonQuitarTodos,
    BotonMasInfo,
  },
  data(){
    return {
      tooltips:tooltips
    }
  }
};
</script>

<style>
.contenedor-tooltip{
  max-height: 100% !important;
}
/* temporalmente se agregan estas clases porque el icon de daimaps no jalo los colores*/
.st0{fill:#DDDDDD;}
.st1{fill:#141414;}
</style>